import React, { useState } from 'react';
import { axiosClient } from '../services/api';
import { useI18n } from '../i18n/i18nContext';

const NewsletterSubscription: React.FC = () => {
  const { t } = useI18n();
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!firstName || !lastName || !email) return;

    setStatus('loading');
    try {
      await axiosClient.post('/api/newsletter/subscribe', {
        firstName,
        lastName,
        email,
      });
      setStatus('success');
      setFirstName('');
      setLastName('');
      setEmail('');
    } catch (err) {
      console.error(err);
      setStatus('error');
    }
  };

  return (
    <div className="w-full bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl mx-auto text-center">
        <h2 className="text-2xl font-bold text-gray-900 mb-4">
          {t.newsletter.title}
        </h2>
        <p className="text-gray-600 mb-8">
          {t.newsletter.subtitle}
        </p>

        {status === 'success' ? (
          <div className="p-4 bg-green-100 text-green-700 rounded-md">
            {t.newsletter.successMessage}
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="flex flex-col gap-4">
            <div className="flex flex-col sm:flex-row gap-4">
              <input
                type="text"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
                placeholder={t.newsletter.firstNamePlaceholder}
                required
                className="flex-1 min-w-0 px-4 py-3 text-base text-gray-900 placeholder-gray-500 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-black"
              />
              <input
                type="text"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
                placeholder={t.newsletter.lastNamePlaceholder}
                required
                className="flex-1 min-w-0 px-4 py-3 text-base text-gray-900 placeholder-gray-500 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-black"
              />
            </div>
            <div className="flex flex-col sm:flex-row gap-4">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder={t.newsletter.emailPlaceholder}
                required
                className="flex-1 min-w-0 px-4 py-3 text-base text-gray-900 placeholder-gray-500 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-black"
              />
              <button
                type="submit"
                disabled={status === 'loading'}
                className="inline-flex justify-center items-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-black hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-black disabled:opacity-50"
              >
                {status === 'loading' ? t.newsletter.subscribing : t.newsletter.subscribe}
              </button>
            </div>
          </form>
        )}
        
        {status === 'error' && (
          <p className="mt-2 text-sm text-red-600">
            {t.newsletter.errorMessage}
          </p>
        )}
      </div>
    </div>
  );
};

export default NewsletterSubscription;
